import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'gatsby-plugin-intl'
import Layout from '@layouts/Layout'
import { Section1 } from '@templates/privacy-policy'
import Jumbotron from '@components/jumbotron/Jumbotron'
import { faHandshake } from '@fortawesome/free-solid-svg-icons'

const PrivacyPolice = props => {
  const { formatMessage } = useIntl()
  const { pageContext } = props
  const { languageName } = pageContext

  return <Layout languageName={languageName} pageContext={pageContext}>
    <Jumbotron
      icon={faHandshake}
      title={formatMessage({ id: 'privacy-policy' })}
      description=''
    />
    <div className='row'>
      <Section1 className='col-md-12'>
          Privacy Policy
      </Section1>
    </div>
  </Layout>
}

PrivacyPolice.propTypes = {
  pageContext: PropTypes.any
}

export default PrivacyPolice
